module.exports = __webpack_public_path__ + "PatinTPADisabled.png?427434f5e82e2ab0ab51276a280c5db4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PatinTPADisabled.png
// module id = 949
// module chunks = 0